import React from "react";
import "./CategoryView.css";
import educationPng from "../images/education.png";
import healthcarePng from "../images/healthcare.png";
import shoppingPng from "../images/shopping-cart.png";
import foodPng from "../images/food.png";
import othersPng from "../images/other.png";
import CategoriesSummaryCard from "./CategoriesSummaryCard";

const CategoryView = () => {
  const categories = [
    {
      id: 1,
      title: "Education",
      icon: educationPng,
      color: "#7209b7",
    },
    {
      id: 2,
      title: "Healthcare",
      icon: healthcarePng,
      color: "#f72585",
    },
    {
      id: 3,
      title: "Shopping",
      icon: shoppingPng,
      color: "#3a0ca3",
    },
    {
      id: 4,
      title: "Food",
      icon: foodPng,
      color: "#4361ee",
    },
    {
      id: 5,
      title: "Other",
      icon: othersPng,
      color: "#4cc9f0",
    },
  ];

  return (
    <div className="caretory__view">
      {categories.map((cat) => (
        <CategoriesSummaryCard catgry={cat} />
      ))}
    </div>
  );
};

export default CategoryView;
